import { clsx } from "clsx";
import { FC } from "react";
import { formatNumberWithSuffix } from "../../../../common/Number";
import { OrderForm } from "../../../../types/OrderFormTypes";
import { formatDateString } from "../../../date/DateOp";
import classes from "./Context.module.less";

interface ContextProps {
    orderForm?: OrderForm;
}
export const Context: FC<ContextProps> = ({ orderForm }) => {
    if (!orderForm) return null;

    const startDate = orderForm.orderStartDate && new Date(orderForm.orderStartDate!);
    const endDate = orderForm.orderEndDate && new Date(orderForm.orderEndDate!);
    const isEvaluationDone = endDate && startDate;

    const status = isEvaluationDone
        ? endDate > new Date()
            ? "Active"
            : "Past Vendor"
        : "Under Evaluation";

    const years = isEvaluationDone
        ? Math.max(endDate?.getFullYear() - startDate?.getFullYear(), 1)
        : 1;

    const formattedStart = startDate ? formatDateString(startDate) : "No start date";
    const formattedEnd = endDate ? formatDateString(endDate) : "No end date";

    return (
        <>
            <div className={clsx(classes.title, "sectionTitle")}>Context</div>
            <ul className={classes.content}>
                <li>
                    <span className={classes.itemName}>Status: </span>
                    {status}
                </li>
                <li>
                    <span className={classes.itemName}>Contract Term: </span>
                    {formattedStart} - {formattedEnd}
                </li>
                <li>
                    <span className={classes.itemName}>
                        {isEvaluationDone ? "Annual" : "Total"} Spend:{" "}
                    </span>
                    {formatNumberWithSuffix(orderForm.value / years)}
                </li>
            </ul>
        </>
    );
};
